// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2MoE3","loaderOuter":"PageOverlayLoader_loaderOuter__2dNOA"};